'use client';

import { c as _c } from "react/compiler-runtime";
import type { KeyboardEvent } from 'react';
import { PurchaseButton } from '../product-details';
import { MiniPdpFulfillment } from './mini-pdp-fulfillment';
import { MiniPdpQuantity } from './mini-pdp-quantity';
import { MiniPdpVariants } from './mini-pdp-variants';
import { type UseMiniPdpAddToCartProps, useMiniPdpAddToCart } from './model/use-mini-pdp-add-to-cart';
import type { MiniPdpVariantsProps } from './model/use-mini-pdp-variants';
type MiniPdpPurchaseFormProps = UseMiniPdpAddToCartProps & MiniPdpVariantsProps;
const preventImplicitSubmit = (event: KeyboardEvent<HTMLFormElement>) => {
  if (event.key === 'Enter' && !(event.target instanceof HTMLButtonElement)) {
    event.preventDefault();
  }
};
export function MiniPdpPurchaseForm(t0) {
  const $ = _c(15);
  const {
    base,
    product,
    tailored,
    isLoading
  } = t0;
  let t1;
  if ($[0] !== isLoading || $[1] !== product || $[2] !== tailored) {
    t1 = {
      product,
      tailored,
      isLoading
    };
    $[0] = isLoading;
    $[1] = product;
    $[2] = tailored;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    disabled,
    isSubmitting,
    isSuccess,
    submitHandler
  } = useMiniPdpAddToCart(t1);
  let t2;
  if ($[4] !== base || $[5] !== disabled || $[6] !== isLoading || $[7] !== isSubmitting || $[8] !== isSuccess || $[9] !== product || $[10] !== tailored) {
    t2 = product && <><MiniPdpVariants base={base} tailored={tailored} /><MiniPdpFulfillment product={product} tailored={tailored} isLoading={isLoading} /><div className="mini-pdp-drawer__purchase-row"><MiniPdpQuantity product={product} tailored={tailored} isLoading={isLoading} /><PurchaseButton text={isSuccess ? "Added to cart" : "Add to cart"} disabled={disabled} loading={isSubmitting} isSuccess={isSuccess} formId="mini-pdp-form" testId="mini-pdp-add-to-cart" /></div></>;
    $[4] = base;
    $[5] = disabled;
    $[6] = isLoading;
    $[7] = isSubmitting;
    $[8] = isSuccess;
    $[9] = product;
    $[10] = tailored;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== submitHandler || $[13] !== t2) {
    t3 = <form id="mini-pdp-form" data-testid="mini-pdp-form" className="mini-pdp-drawer__form" onKeyDown={preventImplicitSubmit} onSubmit={submitHandler}>{t2}</form>;
    $[12] = submitHandler;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}